import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "@mui/material/styles";
import AOS from "aos";
import App from "./App";
import theme from "./utils/theme";
import { HelmetProvider } from "react-helmet-async";
import "./utils/styles.css";
import "react-lazy-load-image-component/src/effects/blur.css";

AOS.init({
  // @ts-ignore
  easing: "custom-easing",
  anchorPlacement: "top-center",
  once: true,
  duration: 600,
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </ThemeProvider>
  </React.StrictMode>
);
